export default {"src":"/kaimono/_next/static/media/tw_hk_wamazing_transport_h.1968b03a.svg","height":116,"width":307};